import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { checkInputErrorMaxLength, checkInputErrorRequired, useInput, useSelect } from '@chilecompra/react-kit'
import { Input, Select, Typography } from '@chilecompra/react-kit/components'
import { useImperativeFormRef } from './QuoteStepOne.hooks'
import { Grid } from './QuoteStepOne.styles'
import { useConfig } from '../ConfigProvider/ConfigProvider.hook'

/**
 * The DeliveryAddress's component.
 */
const DeliveryAddress = props => {
  const {
    delivery: { address, district, region },
    districts,
    formRef,
    isDownToTiny,
    onRegionChange
  } = props

  const { regionInfo } = useConfig()
  const regionOption = regionInfo?.regions?.filter(option => option.value !== '')
  const { authInfo } = useSelector(state => state.authorizationProvider)

  const {
    error: regionError,
    value: regionValue,
    onChange: handleStateChange
  } = useSelect({
    changeCallback: onRegionChange,
    errorCallbacks: [checkInputErrorRequired()],
    initialValue: region?.id,
    overwriteCallback: () => region?.id
  })
  const {
    error: districtError,
    value: districtValue,
    onChange: handleDistrictChange
  } = useSelect({
    errorCallbacks: [checkInputErrorRequired()],
    initialValue: district?.id,
    overwriteCallback: () => district?.id
  })
  const {
    error: addressError,
    value: addressValue,
    onChange: handleAddressChange
  } = useInput({
    errorCallbacks: [checkInputErrorRequired(), checkInputErrorMaxLength(500)],
    overwriteCallback: () => address
  })

  useImperativeFormRef(
    formRef,
    () => ({
      addressError,
      addressValue,
      districtError,
      districtValue,
      regionError,
      regionValue
    }),
    [addressError, addressValue, districtError, districtValue, regionError, regionValue]
  )

  return (
    <Grid container margin="24px 0 24px">
      <Grid container item sm direction="column" padding={isDownToTiny ? '0' : '2px 32px 0 0'} xs={12}>
        <Typography fontWeight="bold" variant="body2">
          Dirección de entrega
        </Typography>
        <Typography fontWeight="regular" color="black1" variant="body2">
          Ingresa la dirección de entrega o ejecución de los servicios.
        </Typography>
      </Grid>
      <Grid item sm={8} xs={12}>
        <Grid container item sm>
          <Grid item padding={isDownToTiny ? '16px 0 0' : '0 16px 0 0'} sm={6} xs={12}>
            <Select
              disabled={authInfo.hasObserverRole}
              error={regionError}
              label="Región"
              loading={regionInfo?.loading}
              options={regionOption || []}
              value={regionValue}
              onChange={handleStateChange}
            />
          </Grid>
          <Grid item padding={isDownToTiny ? '0' : '0 0 0 16px'} sm={6} xs={12}>
            <Select
              disabled={authInfo.hasObserverRole}
              error={districtError}
              label="Comuna"
              options={districts}
              value={districtValue}
              onChange={handleDistrictChange}
            />
          </Grid>
        </Grid>
        <Grid item>
          <Input
            disabled={authInfo.hasObserverRole}
            error={addressError}
            label="Dirección"
            value={addressValue}
            onChange={handleAddressChange}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

DeliveryAddress.defaultProps = {
  delivery: {},
  districts: [],
  formRef: {
    current: {}
  },
  isDownToTiny: false,
  onRegionChange: () => undefined
}

DeliveryAddress.propTypes = {
  delivery: PropTypes.shape({
    address: PropTypes.string,
    district: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    }),
    region: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })
  }),
  districts: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    })
  ),
  formRef: PropTypes.shape({
    current: PropTypes.shape(Object)
  }),
  isDownToTiny: PropTypes.bool,
  onRegionChange: PropTypes.func
}

export default DeliveryAddress
